import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const WalletAdd = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <>
            <g id={'guts'}>
                <path
                    d='M8.42 21.06C8.79 20.46 9 19.75 9 19C9 16.79 7.21 15 5 15M8.42 21.06C7.73 22.22 6.46
23 5 23C3.54 23 2.27 22.22 1.58 21.06C1.21 20.46 1 19.75 1 19C1 16.79 2.79 15 5 15M8.42
21.06C8.21 21.42 7.94 21.74 7.63 22H17C20 22 22 20 22 17V12C22 9.26 20.33 7.34999 17.75 7.04999C17.51 7.00999
17.26 7 17 7H7C6.72 7 6.45 7.02 6.19 7.06C3.64 7.38 2 9.28 2 12V16.36C2.73 15.53 3.8 15 5 15M6.49172 18.9795H3.51172M5
17.5195V20.5095M22 12.5H19C17.9 12.5 17 13.4 17 14.5C17 15.6 17.9 16.5 19 16.5H22M17.7514 7.04997C17.5114 7.00997
17.2614 6.99998 17.0014 6.99998H7.00141C6.72141 6.99998 6.45141 7.01998 6.19141 7.05998C6.33141 6.77998 6.53141 6.52001 6.77141
6.28001L10.0214 3.02C11.3914 1.66 13.6114 1.66 14.9814 3.02L16.7314 4.78996C17.3714 5.41996 17.7114 6.21997 17.7514 7.04997Z'
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
        </>
    );
};

export default createSvg(
    WalletAdd,
    'wallet-add',
);
